import { Context } from '../../sdk/types';
import { InternalAppAction, RequestMessage } from '../../types/actions';
import {
  InpPerformanceReport,
  LcpPerformanceReport,
  LogType,
  NetworkPerformanceReport,
  PerformanceType,
  TtfbPerformanceReport,
} from '../types';

class LogUncaughtErrorRequest extends RequestMessage {
  value: { type: LogType; error: string };

  constructor(error: string) {
    super(InternalAppAction.LOGGER_LOG, {
      type: LogType.UNCAUGHT_ERROR,
      error,
    });
  }
}

class LogUnhandledRejectionRequest extends RequestMessage {
  value: { type: LogType; rejection: string };

  constructor(rejection: string) {
    super(InternalAppAction.LOGGER_LOG, {
      type: LogType.UNHANDLED_REJECTION,
      rejection,
    });
  }
}

class LogLcpPerformanceRequest extends RequestMessage {
  value: {
    type: LogType;
    performanceType: PerformanceType;
    performanceReport: LcpPerformanceReport;
  };

  constructor(lcpPerformanceReport: LcpPerformanceReport) {
    super(InternalAppAction.LOGGER_LOG, {
      type: LogType.PERFORMANCE,
      performanceType: PerformanceType.LCP,
      performanceReport: lcpPerformanceReport,
    });
  }
}

class LogTtfbPerformanceRequest extends RequestMessage {
  value: {
    type: LogType;
    performanceType: PerformanceType;
    performanceReport: TtfbPerformanceReport;
  };

  constructor(ttfbPerformanceReport: TtfbPerformanceReport) {
    super(InternalAppAction.LOGGER_LOG, {
      type: LogType.PERFORMANCE,
      performanceType: PerformanceType.TTFB,
      performanceReport: ttfbPerformanceReport,
    });
  }
}

class LogInpPerformanceRequest extends RequestMessage {
  value: {
    type: LogType;
    performanceType: PerformanceType;
    performanceReport: InpPerformanceReport;
  };

  constructor(inpPerformanceReport: InpPerformanceReport) {
    super(InternalAppAction.LOGGER_LOG, {
      type: LogType.PERFORMANCE,
      performanceType: PerformanceType.INP,
      performanceReport: inpPerformanceReport,
    });
  }
}

class LogNetworkPerformanceRequest extends RequestMessage {
  value: {
    type: LogType;
    performanceType: PerformanceType;
    performanceReport: NetworkPerformanceReport;
  };

  constructor(networkPerformanceReport: NetworkPerformanceReport) {
    super(InternalAppAction.LOGGER_LOG, {
      type: LogType.PERFORMANCE,
      performanceType: PerformanceType.NETWORK,
      performanceReport: networkPerformanceReport,
    });
  }
}

class LogContextRequest extends RequestMessage {
  value: { type: LogType; context: Context };

  constructor(context: Context) {
    super(InternalAppAction.LOGGER_LOG, {
      type: LogType.CONTEXT,
      context,
    });
  }
}

export {
  LogContextRequest,
  LogInpPerformanceRequest,
  LogLcpPerformanceRequest,
  LogNetworkPerformanceRequest,
  LogTtfbPerformanceRequest,
  LogUncaughtErrorRequest,
  LogUnhandledRejectionRequest,
};
